import { useTranslation } from "react-i18next";
import { Text } from "@hawkins/components";

import { TranslationNamespace } from "../../types";
import { useContentfulTranslation } from "../../hooks/useContentfulTranslation";
import { prepareContentfulHtml } from '@lep-shared/richTextHtml';
import { LoadingOverlay } from "../LoadingOverlay";
import { Page } from "../Page";

export default function FAQ() {
  const { t } = useTranslation(TranslationNamespace.LEP);
  const { getContentfulEntry, isReady } = useContentfulTranslation();

  if (!isReady) {
    return <LoadingOverlay />;
  }

  const contentfulData = getContentfulEntry("4gNOgIFCezOJ3gy4VIefyl");
  if (!contentfulData) {
    console.error("Contentful data not found for FAQ page");
    return (
      <Page showBack={true} backPath="/">
        <Text>{t('error_msg_2')}</Text>
      </Page>
    );
  }

  return (
    <Page showBack={true} backPath="/">
      <div
        dangerouslySetInnerHTML={{
          __html: prepareContentfulHtml(contentfulData.body),
        }}
      />
    </Page>
  );
}
